import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import {AbstractAddToken} from "@datagrupo2/dg-ng";
import {TokenService} from "../../../services/token-service/token.service";
import {CognitoAuthService} from "../../auth/cognito/cognito-auth.service";
import {environment} from "src/environments/environment";
import {urlApiCognito} from "../../auth/cognito/cognito-api";

@Injectable()
export class AddTokenInterceptor extends AbstractAddToken implements HttpInterceptor {
  token: TokenService;
  private cognito = inject(CognitoAuthService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
    const token = inject(TokenService);

    super(token);

    this.token = token;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // O Cognito não recebe o nosso Bearer. São DOIS hosts: o domínio de auth
    // (/oauth2/*, que autentica por client_id + code_verifier) e a API
    // (cognito-idp.<region>.amazonaws.com, do InitiateAuth e do ForgotPassword,
    // que não autentica por header nenhum). Mandar o token para qualquer um dos
    // dois só serviria para vazá-lo.
    if (this.ehHostDoCognito(request.url)) {
      return next.handle(request);
    }

    if (this.ehUrlExterna(request.url)) {
      return next.handle(request);
    }

    return this.rootIntercept(request, next).pipe(
      catchError((erro) => {
        // Access de 1h: a sessão pode vencer no meio de uma navegação já
        // carregada, onde o SessionGuard não roda de novo. Uma renovação, um
        // retry — se falhar, o erro segue e o guard cuida na próxima rota.
        if (erro?.status !== 401 || !this.cognito.ehSessaoDoCognito()) {
          return throwError(() => erro);
        }
        return this.cognito.renovar().pipe(
          switchMap(() => this.rootIntercept(request, next)),
          catchError(() => throwError(() => erro)),
        );
      }),
    );
  }

  private ehUrlExterna(url: string): boolean {
    const apiUrl = environment.apiUrl;
    if (!apiUrl) return false;
    return !url.startsWith(apiUrl);
  }

  private ehHostDoCognito(url: string): boolean {
    const cfg = environment.cognito;
    if (!cfg) return false;
    return url.startsWith(cfg.domain) || url.startsWith(urlApiCognito(cfg.region));
  }

  pipeRequestRefreshToken(resp: any): string {
    throw 'a leitura do campo de retorno ainda não foi feita, faça isso em "AddTokenInterceptor"'
  }
}
